import React from "react";

export default function BetaTag() {
  return (
    <span
      style={{
        position: "absolute",
        top: 1,
        right: 1,
        padding: "0 3px",
        borderRadius: 3,
        fontSize: 7,
        fontWeight: 700,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        lineHeight: "11px",
        background: "#FEF3C7",
        color: "#B45309",
        border: "1px solid #FDE68A",
        zIndex: 2,
      }}
    >
      Beta
    </span>
  );
}
